
<template>
    <ion-toolbar>
        <ion-buttons slot="end">
            <slot name="actions">
                <ion-button size="large" fill="outline" shape="round" color="danger" v-if="count > 0">
                    <ion-badge size="large" color="danger">{{ count }}</ion-badge>
                </ion-button>
            </slot>
        </ion-buttons>
        <ion-title><slot /></ion-title>
    </ion-toolbar>
</template>

<script>

    import {
        IonToolbar,
        IonButtons,
        IonButton,
        IonTitle,
        IonBadge
    } from '@ionic/vue';

    export default {
        name: 'sub-title',
        props: {count: Number, subTitle: String, 'hide-count': Boolean},
        components: {
            IonBadge, IonButton, IonTitle, IonButtons, IonToolbar
        },
    }
</script>
<style scoped>
    ion-title {
        text-transform: uppercase;
        display: inline-block;
        vertical-align: middle;
    }
</style>
